module.exports = __webpack_public_path__ + "img/71.b9a91587.jpg";